import {Factory, StandardEntity} from '@infodata-group/inf-commons';

export class AbsenceStatusFactory implements Factory<StandardEntity>{
  build(o: any): StandardEntity {
    return new StandardEntity(o.InternalCode, o.Label, 'label');
  }

  getApi(): string {
    return 'absence-status';
  }
}
